// extracted by mini-css-extract-plugin
export default {"whatsapp":"styles_whatsapp__6IBob","wrapper":"styles_wrapper__wtnR8"};